export const path = "https://serverbackend-udyb.onrender.com/"
export const background = {uri: 'https://raw.githubusercontent.com/tomnisim/ScooterGotcha/main/adminApp/assets/background.png'};
